export default __webpack_public_path__ + "effc7ec1e9eb3a4028171e9696ee7782.png";